import React from "react"

import { ScrollReveal, ScrollRevealItem } from "../../WebsiteBuilderV2/components/shared/ScrollReveal"

import ProCardGridItem from "./ProCardGridItem"
import ProCardSkeleton from "./ProCardSkeleton"

const FeaturedProsLandingSection = ({
  practitioners = [],
  isMobile = false,
  location = "97703",
  isLoading = false
}) => {
  const hasPractitioners = Array.isArray(practitioners) && practitioners.length > 0

  if (!hasPractitioners && !isLoading) return null

  const formatLocation = (loc) => {
    if (!loc || loc === "97703") return "Austin"
    const parts = loc.split(",").map((p) => p.trim())
    if (parts.length >= 2) {
      const city = parts[0]
      return city
    }
    return loc
  }

  const displayLocation = formatLocation(location)

  const buildSearchUrl = () => {
    const params = new URLSearchParams()
    if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
      const storedQuery = sessionStorage.getItem("homepageSearchQuery")
      if (storedQuery && storedQuery.trim()) params.set("query", storedQuery)
    }
    if (typeof window === "undefined") {
      if (location && location !== "97703") params.set("location", location)
      return `/practitioner-search?${params.toString()}`
    }
    const storedLatLng = sessionStorage.getItem("latlng")
    if (storedLatLng) {
      try {
        const parsed = JSON.parse(storedLatLng)
        if (Array.isArray(parsed) && parsed.length === 2) {
          const [lat, lng] = parsed
          params.set("mapCenter", `${lat},${lng}`)
          return `/practitioner-search?${params.toString()}`
        }
      } catch (e) {
        // fallback
      }
    }
    if (location && location !== "97703") params.set("location", location)
    return `/practitioner-search?${params.toString()}`
  }

  return (
    <ScrollReveal
      as="section"
      variant="fadeIn"
      threshold={0.08}
      className={`w-full bg-white ${isMobile ? "py-6" : "py-12"}`}>
      <div className={`mx-auto ${isMobile ? "w-full px-6" : "max-w-[1800px] px-[72px]"}`}>
        <ScrollRevealItem staggerIndex={0} variant="fadeUp" className="mb-5">
          <a
            href={buildSearchUrl()}
            className="group inline-flex items-center gap-2 transition-opacity hover:opacity-80">
            <h2
              style={{
                color: "var(--hm--black, #0B3954)",
                fontFamily: '"Source Serif 4", serif',
                fontSize: isMobile ? "20px" : "24px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: isMobile ? "28px" : "32px",
                fontFeatureSettings: "'liga' off, 'clig' off"
              }}>
              Practitioners near {displayLocation}{" "}
            </h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="14"
              viewBox="0 0 17 14"
              fill="none"
              className="landing-section-title-arrow shrink-0"
              aria-hidden="true">
              <path
                d="M9.5 0.75L15.75 7M15.75 7L9.5 13.25M15.75 7H0.75"
                stroke="#0B3954"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"></path>
            </svg>
          </a>
        </ScrollRevealItem>

        {/* Grid of Pro Cards - on mobile the list overflows the container padding (full-bleed carousel) */}
        {isLoading ? (
          isMobile ? (
            <div
              className="-mx-6 overflow-x-auto overflow-y-hidden [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
              style={{ touchAction: "pan-x pan-y" }}>
              <div className="px-6">
                <div className="grid auto-cols-[152px] grid-rows-2 gap-5 [grid-auto-flow:column]">
                  {Array.from({ length: 8 }).map((_, index) => (
                    <div key={index}>
                      <ProCardSkeleton mobile={isMobile} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-6 gap-6 2xl:grid-cols-6 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1">
              {Array.from({ length: 12 }).map((_, index) => (
                <ProCardSkeleton key={index} mobile={isMobile} />
              ))}
            </div>
          )
        ) : isMobile ? (
          <div
            className="-mx-6 overflow-x-auto overflow-y-hidden [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
            style={{ touchAction: "pan-x pan-y" }}>
            <div className="px-6">
              <div className="grid auto-cols-[152px] grid-rows-2 gap-5 [grid-auto-flow:column]">
                {practitioners.map((practitioner, index) => (
                  <ProCardGridItem
                    key={practitioner?.practice?.id || index}
                    practitioner={practitioner}
                    index={index}
                    isMobile={isMobile}
                    href={practitioner?.practice?.url || "#"}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-6 gap-6 2xl:grid-cols-6 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1">
            {practitioners.map((practitioner, index) => (
              <ProCardGridItem
                key={practitioner?.practice?.id || index}
                practitioner={practitioner}
                index={index}
                isMobile={isMobile}
                href={practitioner?.practice?.url || "#"}
              />
            ))}
          </div>
        )}
      </div>
    </ScrollReveal>
  )
}

export default FeaturedProsLandingSection
